import { EnrollmentFormDenormalized } from '@dadohr/shared/domainTypes/enrollmentForms';
import styled from '@emotion/styled';
import { Box, Button, Popover, Typography } from '@material-ui/core';
import { HelpCircle } from 'lucide-react';
import React, { useState } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';

import { MailTo } from '../../../../components/MailTo';
import { useTranslation } from '../../../../i18next';
import { TopNavProps } from '../../../components/TopNav';

const MobileMenu = styled(MobileView)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${(p) => p.theme.spacing(0.5)}px;
`;

export const Help = ({ d }: { d: TopNavProps }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const onClickMenu = (e: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(e.currentTarget);
  const onCloseMenu = () => setAnchorEl(null);
  const menuOpen = anchorEl !== null;
  const { t } = useTranslation();

  if (!d.mail) {
    return null;
  }

  return (
    <>
      <BrowserView>
        <Typography variant="caption">
          {t('mail.needHelp')} {t('mail.reachOut')}{' '}
          <MailTo color="primary" email={d.mail.email} subject={`[${d.title}]`}>
            {d.mail.name || d.mail.email}
          </MailTo>
        </Typography>
      </BrowserView>
      <MobileMenu style={{}}>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          startIcon={<HelpCircle size={16} />}
          onClick={onClickMenu}
        >
          {t('mail.needHelp')}
        </Button>
        <Popover
          open={menuOpen}
          anchorEl={anchorEl}
          elevation={8}
          onClose={onCloseMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <Box p={2}>
            {t('mail.reachOut')}{' '}
            <MailTo
              color="primary"
              email={d.mail.email}
              subject={`[${d.title}]`}
            >
              {d.mail.name || d.mail.email}
            </MailTo>
          </Box>
        </Popover>
      </MobileMenu>
    </>
  );
};

export const HelpEnrollmentForm = ({
  d
}: {
  d: EnrollmentFormDenormalized;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const onClickMenu = (e: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(e.currentTarget);
  const onCloseMenu = () => setAnchorEl(null);
  const menuOpen = anchorEl !== null;

  const { t } = useTranslation();
  const mailContact = d.mailContact;
  return (
    <>
      <BrowserView>
        <Typography variant="caption">
          {t('mail.needHelp')} {t('mail.reachOut')}{' '}
          <MailTo
            color="primary"
            email={mailContact.email}
            subject={`[${d.experienceTitle}]`}
          >
            {mailContact.name || mailContact.email}
          </MailTo>
        </Typography>
      </BrowserView>
      <MobileMenu style={{}}>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          startIcon={<HelpCircle size={16} />}
          onClick={onClickMenu}
        >
          {t('mail.needHelp')}
        </Button>
        <Popover
          open={menuOpen}
          anchorEl={anchorEl}
          elevation={8}
          onClose={onCloseMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <Box p={2}>
            {t('mail.reachOut')}{' '}
            <MailTo
              color="primary"
              email={mailContact.email}
              subject={`[${d.experienceTitle}]`}
            >
              {mailContact.name || mailContact.email}
            </MailTo>
          </Box>
        </Popover>
      </MobileMenu>
    </>
  );
};
